import React from 'react';
import { SvgIcon } from '@material-ui/core';

const VerticalIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <path fillRule="evenodd" clipRule="evenodd" d="M30 15H2.64919e-09L0 12.3333H30V15Z" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4106 26.7977C4.73217 26.928 5.08477 27 5.45457 27H6.64775V25.6667H5.45457C5.26716 25.6667 5.09184 25.6305 4.93295 25.566L4.4106 26.7977ZM23.3523 27H24.5455C24.9153 27 25.2679 26.928 25.5894 26.7977L25.0671 25.566C24.9082 25.6305 24.7329 25.6667 24.5455 25.6667H23.3523V27ZM2.72729 22.8333V24.3333C2.72729 24.6949 2.80089 25.0397 2.93424 25.3541L4.19387 24.8434C4.12798 24.688 4.09093 24.5166 4.09093 24.3333V22.8333H2.72729ZM2.72729 19.8333V16.8333H4.09093V19.8333H2.72729ZM27.2727 16.8333V19.8333H25.9091V16.8333H27.2727ZM27.2727 22.8333V24.3333C27.2727 24.6949 27.1992 25.0397 27.0658 25.3541L25.8062 24.8434C25.8721 24.688 25.9091 24.5166 25.9091 24.3333V22.8333H27.2727ZM20.9659 27L18.5796 27V25.6667H20.9659V27ZM16.1932 27H13.8068V25.6667H16.1932V27ZM11.4205 27H9.03411V25.6667H11.4205V27Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.45457 4.33333H24.5455C25.2986 4.33333 25.9091 4.93029 25.9091 5.66667V11H27.2727V5.66667C27.2727 4.19391 26.0517 3 24.5455 3L5.45457 3C3.94834 3 2.72729 4.19391 2.72729 5.66667V11H4.09093V5.66667C4.09093 4.93029 4.70145 4.33333 5.45457 4.33333Z"
      />
    </SvgIcon>
  );
};

export default VerticalIcon;
